// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"_93444fe79c--tooltip--j2c8Q","cont":"_93444fe79c--cont--AiuVg","text":"_93444fe79c--text--vYgIS"};